<template>
  <div
    class="filter-slider"
    :class="{
      'filter-slider--active': isActive
    }"
  >
    <span
      v-if="label"
      class="filter-slider__label"
    >{{ label }}</span>
    <vue-slider
      :min="min"
      :max="max"
      :enable-cross="true"
      :value="value"
      :interval="interval"
      tooltip="none"
      dotSize="16"
      @change="onChange"
    />
    <div class="filter-slider__slider-labels">
      <span class="filter-slider__slider-label filter-slider__slider-label--min">{{ valueMin }}</span>
      <span class="filter-slider__slider-label filter-slider__slider-label--max">{{ valueMax }}</span>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component/dist-css/vue-slider-component.umd.min.js'
import 'vue-slider-component/theme/default.css'

export default {
  name: 'FilterSlider',
  components: {
    VueSlider,
  },
  props: {
    label: {
      type: String,
      required: false,
      default: null
    },
    max: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    interval: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    isActive() {
      return this.value[0] !== this.min || this.value[1] !== this.max
    },
    valueMin() {
      return this.value[0].toFixed(this.decimalPadding)
    },
    valueMax() {
      return this.value[1].toFixed(this.decimalPadding)
    },
    decimalPadding() {
      if (Math.floor(this.interval) !== this.interval) return this.interval.toString().split('.')[1].length || 0
      if (Math.floor(this.min) !== this.min) return this.min.toString().split('.')[1].length || 0
      if (Math.floor(this.max) !== this.max) return this.max.toString().split('.')[1].length || 0
      return 0
    }
  },
  methods: {
    onChange ($evt) {
      this.$emit('input', $evt)
    },
  },
}
</script>

<style lang="scss">
@import "src/scss/toolkit";

.filter-slider {
  position: relative;

  &__label {
    font-size: rem(14);
    color: palette('grey');
  }

  .vue-slider-rail {
    position: relative;
    margin: 0 0.375rem;
    background-color: palette('lighter-grey');
    height: 4px;
    border-radius: 2px;
  }

  .vue-slider-process {
    position: absolute;
    background-color: palette('lighter-grey');
  }

  .vue-slider-dot {
    position: absolute;
  }

  .vue-slider-dot-handle {
    background-color: palette('grey');
    box-shadow: none;
    border: 2px solid palette('white');
  }

  &--active {
    .vue-slider-process,
    .vue-slider-dot-handle {
      background-color: palette('blue');
    }
  }

  .filter-slider__slider-labels {
    display: flex;
    justify-content: space-between;
    color: palette('grey');
    font-size: 0.75rem;
    font-weight: bold;
  }

  .filter-slider__slider-label--max {
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/atoms/FilterSlider.vue